/**
 * Created by 丸子 on 2018/7/1.
 */
import Vue from 'vue'
import axios from 'axios'
import '../style/style.scss'
import store from '../store'
import sessionStore from '../store/session'
import * as context from './context'
import {injectVueContext} from './index'
import '../filter'
import Vant from 'vant';
import 'vant/lib/index.css';
import VueI18n from 'vue-i18n'
import animated from 'animate.css'
// import '@/assets/css/tailwind.css'
import { Step,Select,Option,Dropdown,DropdownMenu,DropdownItem,Carousel,CarouselItem, Tooltip,Steps } from 'element-ui';

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

import AlloyFinger from 'alloyfinger'
import AlloyFingerPlugin from 'alloyfinger/vue/alloy_finger_vue'
Vue.use(AlloyFingerPlugin,{
  AlloyFinger
})

Vue.use(Vant);
Vue.use(VueI18n)
Vue.use(animated)

Vue.use(Select)
Vue.use(Option)
Vue.use(Dropdown)
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Tooltip);
Vue.use(Steps);
Vue.use(Step);

export const picUrl = 'https://three-kingdom.oss-cn-shenzhen.aliyuncs.com/'
var i18nNameMap = {
  'zh': '繁体中文',
  'en': 'English',
}
var lang = localStorage.getItem('lang');
if (!lang || !i18nNameMap[lang]) {
  lang = 'zh';
}
const i18nMessages ={
  'zh': require('@/assets/languages/zh.json'),
  'en': require('@/assets/languages/en.json')
}
export const i18n = new VueI18n({
  locale: lang,
  messages:i18nMessages
})
var i18nData = {
  lang: lang,
  nameMap: i18nNameMap,
  messages: i18nMessages
};
Vue.mixin({
  data: function () {
    return {
      i18n: i18nData
    }
  },
  methods: {
    selectLang: function (langKey) {
      this.i18n.lang = langKey;
      this.$i18n.locale = langKey;
      localStorage.setItem('lang', langKey)
    }
  }
})

/**
 * @email: 630514215@qq.com
 * @author: timmy.tan
 * @time: 2022-07-29 14:23:24
 * @description: 全局设置活动 时间
 */
const activityStartTime='2023/07/8 00:00:00'
const activityEndTime='2023/08/8 23:59:59'

Vue.prototype.$activityStartTime=new Date(activityStartTime).getTime()
Vue.prototype.$activityEndTime=new Date(activityEndTime).getTime()

Vue.prototype.$bus = new Vue()
Vue.config.productionTip = true

window.IS_PROD = process.env.NODE_ENV === 'production'
// 图片服务器路径
window.IMG_HOST = process.env.NODE_ENV === 'production' ? '' : '/';

// 后端服务器 URL
// window.API_HOST = process.env.NODE_ENV === 'production' ? 'https://www.nft-hero.vip' : '/online'
// window.API_HOST = process.env.NODE_ENV === 'production' ? 'http://data.seibanet.cn/' : '/online'
// 正式: 'http://heroapi.juhuixinkj.com/api/threeKingdom/',
// 测试: '//heroapi.juhuixinkj.com/api/testthreeKingdom/',
window.API_HOST = process.env.NODE_ENV === 'production' ? '//api.ioi.fun/' : '/online'

// WEB 根路径 URL
window.WEB_URL = process.env.NODE_ENV === 'production' ? '' : ''

// 后端服务器 API URL
window.API_BASE_URL = window.API_HOST

Vue.prototype.$axios = axios

if (process.env.NODE_ENV !== 'production') {
  axios.defaults.withCredentials = false
}
store.registerModule('session', sessionStore())

// 拦截器
axios.interceptors.request.use(function (config) {
  return config
}, function (error) {
  return Promise.reject(error)
})
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.baseURL = window.API_BASE_URL

injectVueContext(context)


